const config = require("config");
/* globals ALKMaps */
(function () {
  var serviceId = "vehicleService";

  angular
    .module("app")
    .factory(serviceId, [
      "$http", "$q", "$rootScope", "_", "mapService", "routeService", "$window", "$compile", "LocationItem", "UserProvider", "routingProfile", "routeSyncService",
      function vehicleService($http, $q, $rootScope, _, mapService, routeService, $window, $compile, LocationItem, userProvider, routingProfile, routeSyncService) {
        var dataServiceUrl = config.daUrl;
        var authServiceUrl = config.ssoUrl;
        var pcmServiceUrl = config.pcmwsUrl;
        var vehicleList = [];
        var selectedVehicle;
        var vehiclesLayer;

        var mapObj = mapService.getMap();
        var vehiclesShown = false;

        var vehicleStyleMap = new ALKMaps.StyleMap({
          default: new ALKMaps.Style({
            graphicName: "circle",
            pointRadius: 10,
            fillColor: "${fill}",
            fillOpacity: 1,
            strokeColor: "${stroke}",
            strokeWidth: 2,
            label: "${labelTxt}",
            labelXOffset: 0,
            labelYOffset: 0,
            fontColor: "${labelColor}",
            fontSize: "9px",
            fontWeight: "normal",
            display: "block",
            graphicZIndex: 0
          }, {
            context: {
              fill: function (feature) {
                if (feature.cluster) {
                  return "#d76852";
                } else {
                  if (feature.attributes.info.OnlineStatus === 1) {
                    return "#5dc25d";
                  } else {
                    return "#ffffff";
                  }
                }
              },
              stroke: function (feature) {
                if (feature.attributes.info.OnlineStatus === 1) {
                  return "#359235";
                } else {
                  return "#666666";
                }
              },
              labelTxt: function (feature) {
                if (feature.cluster) {
                  return "+";
                } else {
                  if (feature.attributes.info.OnlineStatus === 1) {
                    return "on";
                  } else {
                    return "off";
                  }
                }
              },
              labelColor: function (feature) {
                if (feature.attributes.info.OnlineStatus === 1) {
                  return "#ffffff";
                } else {
                  return "#333333";
                }
              },
            }
          }),
          select: {
            strokeColor: "#6ccff6",
            graphicZIndex: 1000
          },
          temporary: {
            strokeColor: "#6ccff6"
          }
        });

        function createVehicleLayer () {
          vehiclesLayer = new ALKMaps.Layer.VectorMarkers("Vehicle Markers", {
            styleMap: vehicleStyleMap
          });
          mapObj.addLayers([ vehiclesLayer ]);

          var eventSelect = new ALKMaps.Control.FeatureEvent([ vehiclesLayer ], {
            featureAttributesFilter: [ {
              property: "isMarker",
              value: true
            } ]
          });
          mapObj.addControls([ eventSelect ]);
          eventSelect.activate();

          //Display VectorMarker popup on click
          var clickHandler = function (event) {
            if (mapObj.vehiclePopup) {
              mapObj.removePopup(mapObj.vehiclePopup);
            }

            mapObj.vehiclePopup = new ALKMaps.Popup.SimplePopup(
              "vehiclePopup",
              event.feature.lonlat,
              null, //autosize
              getPopupText(event.feature.attributes.info),
              new ALKMaps.Pixel(0, 0), //offset
              true,
              () => {
                if (mapObj.vehiclePopup) {
                  mapObj.removePopup(mapObj.vehiclePopup);
                }
              });

            mapObj.addPopup(mapObj.vehiclePopup);
          };

          vehiclesLayer.events.register("featureclicked", this, clickHandler);
        }

        $rootScope.$on("routeSyncHidden", () => clearVehicleMarker());

        function getPopupText(vehicleObj) {
          return "<div class='popup-text driver-popup-text'>" +
            "<span class='driver-name'>" + vehicleObj.Email + "</span>" +
            "<span class='driver-location driver-info'><strong>Near:</strong> " + vehicleObj.Address.StreetAddress + "<br/>" + vehicleObj.Address.City + " " + vehicleObj.Address.State + "  " + vehicleObj.Address.Zip + "</span>" +
            "<span class='driver-update driver-info'><strong>Updated:</strong> " + vehicleObj.displayDate + "</span>" +
            "</div>";
        }

        function getVehicleList() {
          // is the user is not logged in
          if (userProvider.getUser().isLoggedIn !== true) {
            return;
          }
          var deferred = $q.defer();

          // get RS vehicles
          routeSyncService
            .getVehicles()
            .then((vehicles) => {
              var vehicleData = angular.copy(vehicles);
              for (var i = 0; i < vehicleData.length; i++) {
                if (vehicleData[i].Latitude > 90 || vehicleData[i].Latitude < -90) {
                  vehicleData[i].Latitude = vehicleData[i].Latitude / 1000000;
                }

                if (vehicleData[i].Longitude > 90 || vehicleData[i].Longitude < -90) {
                  vehicleData[i].Longitude = vehicleData[i].Longitude / 1000000;
                }

                var modDate = new Date(vehicleData[i].ModifiedOn / 10000);
                vehicleData[i].displayDate = moment(modDate).format("M/D/YY h:mma");
              }
              vehicleList = vehicleData;
              deferred.resolve(vehicleList);
            }, function (err) {
              deferred.reject(err.ErrorMessage);
            });

          return deferred.promise;
        }

        function hasVehicles() {
          return vehicleList.length > 0;
        }

        function showAllVehicles() {
          vehiclesLayer.clearMarkers();
          if (mapObj.vehiclePopup) {
            mapObj.removePopup(mapObj.vehiclePopup);
          }
          for (var v = 0; v < vehicleList.length; v++) {
            var cleanLL = new ALKMaps.LonLat(vehicleList[v].Longitude, vehicleList[v].Latitude).transform(new ALKMaps.Projection("EPSG:4326"), mapObj.getProjectionObject());
            vehiclesLayer.createMarker(cleanLL, {
              markerType: "custom",
              info: vehicleList[v]
            });
          }
          vehiclesShown = true;
        }

        function hideVehicles() {
          vehiclesLayer.clearMarkers();
          vehiclesShown = false;
        }

        function frameAllVehicles() {
          var vehExt = vehiclesLayer.getDataExtent();
          mapObj.zoomToExtent(vehExt);
        }

        function showVehicle(vehicle, pan) {
          var cleanLL = new ALKMaps.LonLat(vehicle.Longitude, vehicle.Latitude).transform(new ALKMaps.Projection("EPSG:4326"), mapObj.getProjectionObject());
          if (!vehiclesShown) {
            clearVehicleMarker();
            mapObj.vehicleMarker = vehiclesLayer.createMarker(cleanLL, {
              markerType: "custom",
              info: vehicle
            });
          }

          if (mapObj.vehiclePopup) {
            mapObj.removePopup(mapObj.vehiclePopup);
          }

          mapObj.vehiclePopup = new ALKMaps.Popup.SimplePopup(
            "vehiclePopup",
            cleanLL,
            null, //autosize
            getPopupText(vehicle),
            new ALKMaps.Pixel(0, 14), //offset
            true,
            function () {
              clearVehicleMarker();
            });

          mapObj.addPopup(mapObj.vehiclePopup);

          if (pan) {
            mapService.safePanTo(cleanLL, 14);
          }
        }

        function clearVehicleMarker() {
          var retVal = false;

          if (mapObj.vehicleMarker) {
            retVal = true;
            vehiclesLayer.removeMarker(mapObj.vehicleMarker);
            mapObj.vehicleMarker = null;
          }

          if (mapObj.vehiclePopup) {
            mapObj.removePopup(mapObj.vehiclePopup);
          }

          return retVal;
        }

        function getSelectedVehicle(id) {
          return getVehicleById(id);
        }

        function setSelectedVehicle(id) {
          selectedVehicle = id;
        }

        function getVehicleById(id) {
          return _.find(vehicleList, {
            OwnerID: id
          });
        }

        function getAccountShortcode() {
          var deferred = $q.defer();
          var token = userProvider.getUser().authToken;
          $http.get(authServiceUrl + "account-alias", {
            params: {
              "authToken": token
            }
          }).success(function (resp) {
            console.log(resp);
            deferred.resolve(resp.Data);
          }).error(function (err) {
            deferred.reject(resp.ErrorMessage);
          });
          return deferred.promise;
        }

        function resetAccountShortcode(code) {
          var deferred = $q.defer();
          var token = userProvider.getUser().authToken;
          $http.put(authServiceUrl + "account-alias", {}, {
            params: {
              "oldAlias": code,
              "authToken": token
            }
          }).success(function (resp) {
            console.log(resp);
            deferred.resolve(resp.Data);
          }).error(function (err) {
            deferred.reject(resp.ErrorMessage);
          });
          return deferred.promise;
        }

        function getReducedRoutePoints(code) {
          var deferred = $q.defer();
          var token = userProvider.getUser().authToken;
          $http.put(pcmServiceUrl + "route/routePath", {}, {
            params: {
              "oldAlias": code,
              "authToken": token
            }
          }).success(function (resp) {
            console.log(resp);
            deferred.resolve(resp.Data);
          }).error(function (err) {
            deferred.reject(err.ErrorMessage);
          });
          return deferred.promise;
        }

        function sendRSMessage(routeSyncOptions) {
          var route = angular.copy(routeService.getRoute(routeSyncOptions.routeId));
          var mapObj = mapService.getMap();
          var deferred = $q.defer();
          var routeSyncObject = {
            "TargetUser": {
              "OwnerId": routeSyncOptions.ownerId
            },
            "RouteSync": {
              "Compliance": routeSyncOptions.complianceAmount,
              "OorDistance": routeSyncOptions.alertDist,
              "DataVersion": "",
              "Legs": []
            }
          };

          var routeElements = mapService.getRouteElements(route.id);

          for (var f = 0; f < routeElements.routingLayer.features.length; f++) {
            var legNum = 0;
            if (routeElements.routingLayer.features[f].geometry.components) { //only linestrings have components
              var components = routeElements.routingLayer.features[f].geometry.components;
              var leg = {};
              leg.SequenceId = legNum;
              leg.Coords = [];
              leg.Links = []; //this should not be required by the service
              for (var i = 0; i < components.length; i++) {
                var ll = new ALKMaps.LonLat(components[i].x, components[i].y).transform(mapObj.getProjectionObject(), new ALKMaps.Projection("EPSG:4326"));
                leg.Coords.push(Math.round(ll.lon * 1000000));
                leg.Coords.push(Math.round(ll.lat * 1000000));
              }
              routeSyncObject.RouteSync.Legs.push(leg);
              legNum++;
            }
          }

          routeSyncObject.RouteSync.Trip = {
            Name: route.name,
            Stops: _.map(_.map(route.stops, "ALKObj"), function (stop) {
              return {
                "Location": stop
              };
            }),
            Profile: routingProfile.getDARouteOptionsFromPCM(route.options)
          };

          routeSyncService
            .sendRouteSyncMessage(routeSyncObject)
            .then((resp) => {
              deferred.resolve(resp);
            }, (err) => {
              console.error(err);
              deferred.reject(err);
            });

          // $http.post(dataServiceUrl + "routesync-message", routeSyncObject).success(function (resp) {
          //   console.log(resp);
          //   deferred.resolve(resp);
          // }).error(function (err) {
          //   deferred.reject(err);
          // });
          return deferred.promise;
        }

        return {
          createVehicleLayer: createVehicleLayer,
          getVehicleList: getVehicleList,
          hasVehicles: hasVehicles,
          getAccountShortcode: getAccountShortcode,
          resetAccountShortcode: resetAccountShortcode,
          showVehicle: showVehicle,
          showAllVehicles: showAllVehicles,
          frameAllVehicles: frameAllVehicles,
          hideVehicles: hideVehicles,
          getSelectedVehicle: getSelectedVehicle,
          setSelectedVehicle: setSelectedVehicle,
          sendRSMessage: sendRSMessage
        };
      }
    ]);
})();

/*
 {
    "TargetUser": {
        "OwnerId": 2668
    },
    "RouteSync": {
        "Compliance": 0,
        "DataVersion": "9.12.14.3",
        "OorDistance": 0.2,
        "ExternalRouteID": "",
        "StartingIndex": 0,
        "Legs": [
            {
                "SequenceId": 0,
                "Coords": [
                    -74189445,
                    39803416,
                    -74189445,
                    39803416,
                    -74190584,
                    39803545,
                    -74190699,
                    39802870,
                    -74190828,
                    39802254
                ],
        "Trip": {
            "Name": "",
            "Profile": {
                "name": "2147104196",
                "vehicleType": 3,
                "routingType": 0,
                "tollRoadType": 2,
                "truckDimensions": 0,
                "maxHeight": 1620,
                "maxWidth": 960,
                "totalLength": 5760,
                "totalWeight": 8000,
                "totalWeightPerAxle": -1,
                "hazmatType": 0,
                "displayRestrictions": 1,
                "nationalNetwork": false,
                "fiftyThreeFootTrailer": false,
                "overrideRestrictions": true,
                "bordersOpen": true,
                "propane": false,
                "ferryClosed": false
            },
            "Stops": [
                {
                    "Location": {
                        "Address": {
                            "StreetAddress": "10 Mizzen Way",
                            "City": "Waretown",
                            "State": "NJ",
                            "Zip": "08758",
                            "County": "Ocean",
                            "Country": "",
                            "SPLC": "",
                            "CountryPostalFilter": 0,
                            "AbbreviationFormat": 0
                        },
                        "Coords": {
                            "Lat": "39.803416",
                            "Lon": "-74.189445"
                        },
                        "Region": 0,
                        "Label": "",
                        "PlaceName": "",
                        "TimeZone": "",
                        "Errors": ""
                    },
                    "Waypoint": false
                },
                {
                    "Location": {
                        "Address": {
                            "StreetAddress": "933 Wellington Avenue",
                            "City": "Toms River",
                            "State": "NJ",
                            "Zip": "08757",
                            "County": "Ocean",
                            "Country": "",
                            "SPLC": "",
                            "CountryPostalFilter": 0,
                            "AbbreviationFormat": 0
                        },
                        "Coords": {
                            "Lat": "40.004736",
                            "Lon": "-74.266524"
                        },
                        "Region": 0,
                        "Label": "",
                        "PlaceName": "",
                        "TimeZone": "",
                        "Errors": ""
                    },
                    "Waypoint": false
                }
            ]
        }
    }
}
 */



// WEBPACK FOOTER //
// ./app/vehicle/vehicle.service.js